import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { connect } from 'react-redux'
import Select, { components } from "react-select"
import { LogistcsPOsAndLineItem, RequestPayemtForLogistics } from '../store/actions/poDetailsActions'
import { uploadFileGeneric, GenericUploadVersionFile } from '../store/actions/fileActions'
import AuthHandler from '../Classes/AuthHandler';
import formatDate from '../Classes/FormatDate';
import swal from 'sweetalert';
import numberWithCommas from '../Classes/NumberwithComma'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import FormatDateTimeInIST from '../Classes/FormatDateTimeInIST'
import DocumentCommentsByDocumentIdPopUp from '../Components/DocumentCommentsByDocumentIdPopUp';
import { GenericPostCommentsbyDocumentID } from '../store/actions/documentCommentAction'
import { getallMasterData } from '../store/actions/masterActions';
import env from '../ENV';
import FileVersionModal from '../Components/FileVersionModal';
import DropdownFlat from '../Components/DropdownFlat'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class ImportLogistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      PaymentType: [
        { label: "Transportation ", value: "Transportation " },
        { label: "Custom duty", value: "Custom duty" },
        { label: "CHA Charges", value: "CHA Charges" },
        { label: "Freight forwarder", value: "Freight forwarder" },
        { label: "Miscellaneous", value: "Miscellaneous" },
      ],
      POList: [],
      POLineItemList: [],
      ThirdPartyVendorList: [],
      PoId: 0,
      PoLIneItemId: 0,
      VendorCode: "",
      SelectedPaymentType: "",
      InvoiceAmount: 0,
      file: [],
      PODetailsDisplayData: {},
      tableData: [],
      tarilTableData: [],
      Docmodal: false,
      showRevisedPopUp: false,
      OpenVersionmodal: false,
      Acceptmodal: false,
      DocumentCommentsByDocumentIdPopUpModal: false,
      docStatus: {
        0: { title: "Document Sent for Approval", badge: "badge-warning", status: "Approved" },
        1: { title: "Document is Approved", badge: "badge-success", status: "Rejected" },
        2: { title: "Document sent for Revision", badge: "badge-primary", status: "Sent for Revision" },
      },
      varId: "",
      varPoId: '',
      varPoLineId: '',
      reviseForm: {
        file: [],
        comment: ""
      },
      payLoad: '',
      approvalStatus: '',
      ActedgroupId: 0,
      uploadedId: "",
      InvoiceDate: "",
      DueDate: "",
      InvoiceNo: "",
      paymentMethod: [],
    }
    this.DocumentCommentsByDocumentIdPopUpModal = this.DocumentCommentsByDocumentIdPopUpModal.bind(this);
  }
  componentDidMount() {
    this.dataSync()
  }
  dataSync = async () => {
    let input = {
      PoId: this.state.PoId,
      PoLIneItemId: this.state.PoLIneItemId
    }
    await this.props.LogistcsPOsAndLineItem(input)
    let ThirdPartyVendorList = []
    let POList = []
    let POLineItemList = []
    let PODetailsDisplayData = {}
    let paymentMethod = [{
      PaymentMediumId: 0,
      PaymentMediumName: "Select Option"
    }]
    let tableData = await this.props.poDetails.LogisticsData[3]
    await this.props.poDetails.LogisticsData[0].map((elem) => {
      if (!POList.find(data => data.PurchaseOrderId === elem.PurchaseOrderId)) {
        POList.push({ label: elem.POSAPId, value: elem.PurchaseOrderId })
      }
    })
    await this.props.poDetails.LogisticsData[1].map((elem) => {
      if (!POLineItemList.find(data => data.POLineItemSAPCode === elem.PurchaseOrderLineId)) {
        POLineItemList.push({ label: elem.POLineItemSAPCode, value: elem.PurchaseOrderLineId })
      }
    })
    await this.props.poDetails.LogisticsData[2].map(async (elem) => {
      if (elem.CHAVendor !== "") {
        await ThirdPartyVendorList.push({ label: elem.CHAVendor, value: elem.CHAVendor })
      }
      if (elem.LocalFreightVendorCode !== "") {
        await ThirdPartyVendorList.push({ label: elem.LocalFreightVendorCode, value: elem.LocalFreightVendorCode })
      }
      if (elem.MiscellenousChargesVendorCode !== "") {
        await ThirdPartyVendorList.push({ label: elem.MiscellenousChargesVendorCode, value: elem.MiscellenousChargesVendorCode })
      }
      if (elem.OceanFreightVendorCode !== "") {
        await ThirdPartyVendorList.push({ label: elem.OceanFreightVendorCode, value: elem.OceanFreightVendorCode })
      }
      if (elem.PackingAndForwadingValueVendorCode !== "") {
        await ThirdPartyVendorList.push({ label: elem.PackingAndForwadingValueVendorCode, value: elem.PackingAndForwadingValueVendorCode })
      }
      if (elem.PackingAndForwadingVendorCode !== "") {
        await ThirdPartyVendorList.push({ label: elem.PackingAndForwadingVendorCode, value: elem.PackingAndForwadingVendorCode })
      }
    })
    let poDetails = await this.props.poDetails.LogisticsData[0].find(data => data.PurchaseOrderId === this.state.PoId)
    let poLineItemDetails = await this.props.poDetails.LogisticsData[1].find(data => data.PurchaseOrderLineId === this.state.PoLIneItemId)
    PODetailsDisplayData = {
      "POAmount": poDetails != null ? poDetails.POAmount : "",
      "Currency": poDetails != null ? poDetails.Currency : "",
      "Location": poDetails != null ? poDetails.VendorLocation : "",
      "PODate": poDetails != null ? poDetails.POCreationDate : "",
      "VendorSAPId": poDetails != null ? poDetails.VendorSAPId : "",
      "VendorName": poDetails != null ? poDetails.VendorName : "",
      "VendorEmail": poDetails != null ? poDetails.VendorEmail : "",
      "incoTerms": poDetails != null ? poDetails.incoTerms : "",
      "PlantCode": poDetails != null ? poDetails.PlantCode : "",
      "MaterialShortText": poLineItemDetails != null ? poLineItemDetails.MaterialShortText : "",
      "MaterialNumber": poLineItemDetails != null ? poLineItemDetails.MaterialNumber : "",
      "SizeOrDimensions": poLineItemDetails != null ? poLineItemDetails.SizeOrDimensions : "",
      "ItemDescription": poLineItemDetails != null ? poLineItemDetails.POLineItemDescription : "",
      "WBSCode": poLineItemDetails != null ? poLineItemDetails.WBSCode : "",
    }
    await this.props.getallMasterData()
    if (this.props.masterReducerData.loading == false) {
      await this.props.masterReducerData.masterdata.recordset.map(item => {
        paymentMethod.push(item)
      })
    }
    await this.setState({ tableData, POList, POLineItemList, ThirdPartyVendorList, PODetailsDisplayData, paymentMethod, payLoad: '', approvalStatus: '', ActedgroupId: 0 })
  }
  handleSelectPO = async (e) => {
    let PoId = e.value
    await this.setState({ PoId })
    await this.dataSync()
  }
  handleSelectPOLineItems = async (e) => {
    let PoLIneItemId = e.value
    await this.setState({ PoLIneItemId })
    await this.dataSync()
  }
  handleSelectVendor = async (e) => {
    let VendorCode = e.value
    await this.setState({ VendorCode })
    await this.dataSync()
  }
  handleSelectPaymentType = async (e) => {
    let SelectedPaymentType = e.value
    await this.setState({ SelectedPaymentType })
    await this.dataSync()
  }
  InvoiceAmountInput = async (value) => {
    await this.setState({ InvoiceAmount: value });
  };
  handleFile = async (e) => {
    let file = e.target.files[0]
    await this.setState({ file })
  }
  fileUpload = async () => {
    let input = {}
    if (this.state.file.length == 0) {
      swal("Please select a file!", { buttons: false, timer: 2000, icon: 'error' })
      return false
    }
    if (this.state.PoId == 0 || this.state.PoLIneItemId == 0 || this.state.InvoiceAmount == 0 || this.state.VendorCode == '') {
      swal("Please select all the fields!", { buttons: false, timer: 2000, icon: 'error' })
      return false
    }
    if (this.state.tableData.find(elem => (elem.PoId == this.state.POSAPId))
      && this.state.tableData.find(elem => (elem.PoLIneItemId == this.state.POLineItemSAPCode))
      && this.state.tableData.find(elem => (elem.VendorCode == this.state.ThirdPartyVendorCode))
      && this.state.tableData.find(elem => (elem.PaymentType == this.state.SelectedPaymentType))) {
      swal("This combination of inputs are aleady present", { buttons: false, timer: 2000, icon: 'error' })
      return false
    }
    await this.props.uploadFileGeneric([this.state.file], AuthHandler.getUserID())
      .then(data => {
        input = {
          PoId: this.state.PoId,
          PoLIneItemId: this.state.PoLIneItemId,
          PaymentType: this.state.SelectedPaymentType,
          DocumentId: data.results[0].DocumentId,
          Amount: this.state.InvoiceAmount,
          ThirdPartyVendorCode: this.state.VendorCode,
          approvedBy: AuthHandler.getUserID()
        }
      })
    if (input.DocumentId == null) {
      swal("Something went wrong Please try again later!", { buttons: false, timer: 2000, icon: 'info' })
      return false
    }
    await this.props.RequestPayemtForLogistics(input)
    await this.dataSync()
  }
  Docmodal = async (RequestId) => {
    let tarilTableData = []
    if (RequestId) {
      await this.props.LogistcsPOsAndLineItem({ "RequestId": RequestId })
      tarilTableData = this.props.poDetails.LogisticsData[4]
    }
    this.setState({ Docmodal: !this.state.Docmodal, tarilTableData });
    if (this.state.Docmodal == true) {
      this.setState({ opacity: "" })
    }
    else {
      this.setState({ opacity: "0.2" })
    }
  }
  handleCancel = async () => {
    let reviseForm = {
      file: [],
      comment: ""
    }
    await this.setState({ reviseForm })
    document.getElementById("exampleFormControlFile2").value = "";
    this.revisePopUpAction()
  }
  revisePopUpAction = async (payLoad = '', approvalStatus = '', ActedgroupId = 0) => {
    this.setState({ showRevisedPopUp: !this.state.showRevisedPopUp, payLoad, approvalStatus, ActedgroupId });
    if (this.state.showRevisedPopUp == true) {
      this.setState({ opacity: "" })
    }
    else {
      this.setState({ opacity: "0.2" })
    }
  }
  DocumentCommentsByDocumentIdPopUpModal() {
    this.setState({ DocumentCommentsByDocumentIdPopUpModal: !this.state.DocumentCommentsByDocumentIdPopUpModal });
    this.setState({ RetentionDocumentsModal: false });
    if (this.state.DocumentCommentsByDocumentIdPopUpModal == true) {
      this.setState({ opacity: "" })
    }
    else {
      this.setState({ opacity: "0.2" })
    }
  }
  toggleDocumentCommentsByDocumentIdPopUpModal = async (e) => {
    await this.setState({ DocumentCommentsByDocumentIdPopUpModal: !this.state.DocumentCommentsByDocumentIdPopUpModal, varId: "", varPoId: "", varPoLineId: "" });
    if (this.state.DocumentCommentsByDocumentIdPopUpModal == true) {
      this.setState({ opacity: "" })
    }
    else {
      this.setState({ opacity: "0.2" })
    }
  }
  rowClick = async (documentId, poId, lineitemId) => {
    await this.setState({ varId: documentId, varPoId: poId, varPoLineId: lineitemId })
    await this.DocumentCommentsByDocumentIdPopUpModal(this.state.varId)
  }
  formChange = (e) => {
    console.log("Event", e.target.value);
    let reviseForm = this.state.reviseForm
    reviseForm.comment = e.target.value;
    this.setState({ reviseForm });
  }
  handleFileInputforRevision = (event) => {
    let reviseForm = this.state.reviseForm
    reviseForm.file.push(event.target.files[0])
    this.setState({ reviseForm });
  }
  formSaveAction = async () => {
    if (this.state.ActedgroupId == 20 && this.state.approvalStatus == 0 && this.state.reviseForm.file.length == 0) {
      swal("Please select a file!", { buttons: false, timer: 2000, icon: 'error' })
      return false
    }
    console.log(this.state.InvoiceAmountAp, this.state.InvoiceNo, this.state.InvoiceDate, this.state.DueDate, this.state.payLoad, this.state.approvalStatus, this.state.ActedgroupId, "fffff========>")
    let input = {
      GroupId: this.state.ActedgroupId,
      approvalStatus: this.state.approvalStatus,
      approvedBy: AuthHandler.getUserID(),
      RequestId: this.state.payLoad.LogisticsRequestId,
      Amount: this.state.payLoad.Amount,
      InvoiceNo: this.state.InvoiceNo,
      InvoiceDate: this.state.InvoiceDate,
      DueDate: this.state.DueDate,
      PoId: this.state.payLoad.POId,
      PoLIneItemId: this.state.payLoad.POLineItemId,
      PaymentType: this.state.payLoad.PaymentType,
      DocumentId: this.state.payLoad.DocumentId,
      PaymentMediumId: this.state.payLoad.PaymentMediumId
    }
    if (this.state.reviseForm.file.length > 0) {
      await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.payLoad.DocumentId, '', AuthHandler.getUserID())
    }
    if (this.state.reviseForm.comment != '') {
      let params = {
        Comment: this.state.reviseForm.comment,
        RoleId: parseInt(Object.keys(AuthHandler.getRoles())[0]),
        GroupId: parseInt(Object.keys(AuthHandler.getGroups())[0]),
        UserId: AuthHandler.getUserID(),
        DocumentId: this.state.payLoad.DocumentId,
        PoId: this.state.payLoad.POId,
        PoLineItemId: this.state.payLoad.POLineItemId,
        rowDocumentTypeId: 0,
        rowDrawingDocumentDetailId: 0,
        indicatorForComments: 1
      }
      await this.props.GenericPostCommentsbyDocumentID(params)
    }
    await this.props.RequestPayemtForLogistics(input)
    await this.dataSync()
    if (this.state.showRevisedPopUp == true) {
      await this.revisePopUpAction()
    }
    if (this.state.Acceptmodal == true) {
      await this.Acceptmodal()
    }
  }
  OpenVersionModal = (uploadedId) => {
    let stateVal = this.state.OpenVersionmodal;
    this.setState({ OpenVersionmodal: !stateVal, uploadedId: uploadedId });
  }
  Acceptmodal = async (payLoad = '', approvalStatus = '', ActedgroupId = 0) => {
    await this.setState({ payLoad, approvalStatus, ActedgroupId, Acceptmodal: !this.state.Acceptmodal });
    if (this.state.Acceptmodal == true) {
      this.setState({ opacity: "" })
    }
    else {
      this.setState({ opacity: "0.2" })
    }
  }
  InvoiceNoInput = async (e) => {
    await this.setState({ InvoiceNo: e.target.value });
  };
  handleDueDate = (event) => {
    this.setState({ DueDate: event.target.value });
  };
  handleInvoiceDate = async (event) => {
    await this.setState({ InvoiceDate: event.target.value });
  };
  InvoiceAmountInputAP = async (value) => {
    let data = this.state.payLoad
    data.Amount = value
    await this.setState({ payLoad: data });
  };
  handleSelect = async (e) => {
    let data = this.state.payLoad
    data.PaymentMediumId = e.target.value
    await this.setState({ payLoad: data });
  };
  render() {
    var group = AuthHandler.getGroups()
    var varId = this.state.varId
    var varPoId = this.state.varPoId
    var varPoLineId = this.state.varPoLineId
    console.log(varPoLineId, "varPoLineId")
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        //   color: state.isSelected ? 'red' : 'blue',
        padding: "2px 10px",
      }),
      container: (provided, state) => ({
        ...provided,
        width: "150px",
      }),
    }
    return (
      <div className="Container-fluid p-4">
        {/*----------File version start  */}
        {this.state.uploadedId && this.state.OpenVersionmodal && <FileVersionModal OpenVersionmodal={this.state.OpenVersionmodal} uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} />}
        {/*----------File version end  */}
        {/*----------Document Comment start  */}
        {varId ? (<DocumentCommentsByDocumentIdPopUp action={this.state.DocumentCommentsByDocumentIdPopUpModal} toggleDocumentCommentsByDocumentIdPopUpModal={(e) => this.toggleDocumentCommentsByDocumentIdPopUpModal(e)} DocumentId={varId} PoId={varPoId} PoLineId={varPoLineId} rowDocumentTypeId={0} rowDrawingDocumentDetailId={0} path='/ExpeditingPOAcceptanceTrail' />) : null}
        {/*----------Document Comment end  */}
        {/* ----Accept Modal Start----- */}

        <Modal isOpen={this.state.Acceptmodal} className="modal-lg">
          <div
            className={
              "modal-bg" + (this.state.Acceptmodal === "false" ? "open" : "")
            }
          >
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header">
                <div>
                  <h4> Proforma Invoice Details </h4>
                </div>
                <button type="button" className="close" aria-label="Close" onClick={this.Acceptmodal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>

            <div>
              <ModalBody Style="modal-body">
                <div className="row pt-2 mt-4">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-7">
                        <b> Proforma Invoice No: </b>
                      </div>
                      <div className="col-md-5">
                        <input type="text" className="form-control text-center" value={this.state.InvoiceNo} onChange={(e) => this.InvoiceNoInput(e)}></input>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <b>Proforma Invoice Date:</b>
                      </div>
                      <div className="col-md-6">
                        <input type="date" max={formatDate(new Date())} className="form-control text-center" value={this.state.InvoiceDate} onChange={(e) => this.handleInvoiceDate(e)}></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row  pt-2 mt-4">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-7">
                        <b> Project code: </b>
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          readOnly
                          className="form-control text-center"
                          value={this.state.payLoad.WBSCode}
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <b> Due Date:</b>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="date"
                          min={formatDate(new Date())}
                          max={formatDate(this.state.InvoiceDate)}
                          className="form-control text-center"
                          value={this.state.DueDate}
                          onChange={this.handleDueDate}
                        ></input>
                      </div>
                    </div>
                  </div>


                </div>
                <div className="row pt-2 mt-4">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-7">
                        <b> Currency: </b>
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          readOnly
                          className="form-control text-center"
                          value={"INR"}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <b>Proforma Invoice Amount: </b>
                      </div>
                      <div className="col-md-6">
                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center"
                          value={this.state.payLoad.Amount}
                          onValueChange={(value, name) => this.InvoiceAmountInputAP(value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row pt-2 mt-4">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-7">
                        <b>Proforma Invoice Amount (INR) : </b>
                      </div>
                      <div className="col-md-5">
                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.payLoad.Amount} readOnly />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <b>Payment Method: </b>
                      </div>
                      <div className="col-md-6">
                        <DropdownFlat selectedValue={this.state.payLoad.PaymentMediumId} defaultopt="Select Option" data={this.state.paymentMethod} actions={(e) => this.handleSelect(e)} keyObjName={"PaymentMediumId"} valueObjName={"PaymentMediumName"} />
                      </div>
                    </div>
                  </div>
                </div>
              </ModalBody>
            </div>
            <div>
              <ModalFooter FooterStyle="modal-footer ">
                <div>
                  <button className="btn2 btn-sms1 mt-2 rounded-pill ml-4 float-right" onClick={() => this.formSaveAction()} type="submit">
                    Accept
                  </button>
                  <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.Acceptmodal}>{" "}Cancel{" "}</button>
                </div>
              </ModalFooter>
            </div>
          </div>
        </Modal>

        {/* ---- Accept Modal End-------- */}
        <Modal isOpen={this.state.Docmodal} className="modal-lg">
          <div className={"modal-bg" + (this.state.Docmodal === 'false' ? 'open' : '')}>
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header  ">
                <div><h4 >Document Details</h4></div>
                <button type="button" className="close" aria-label="Close" onClick={() => this.Docmodal(0, "")} >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>

            <div >
              <ModalBody Style="modal-body modalbodysWideBudget ">
                <div className="col-md-12 pt-2">
                  <div className="row mt-4 align">
                    <div className="col ">
                      <table border="1" className="table1 table" >
                        <thead>
                          <tr className="headerbar ">
                            <th>Acted Person</th>
                            <th>Acted On</th>
                            <th>Action Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.tarilTableData.map((element, index) =>
                            <tr className="rows headeralign" key={index}>
                              <td>{element.FullName}</td>
                              <td>{FormatDateTimeInIST(element.CreatedOn)}</td>
                              <td>{element.approvalStatus == 0 ?
                                `Payment Document Uploaded and Requested By ${element.GroupName}`
                                : element.approvalStatus == 1 ?
                                  `Document Approved By ${element.GroupName}`
                                  : element.approvalStatus == 2 ?
                                    `Document Sent For Revision By ${element.GroupName}`
                                    : null
                              }</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </ModalBody>
            </div>
            <div>
              <ModalFooter FooterStyle="modal-footer ">
                <div>
                  <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.Docmodal(0, "")}> Close </button>
                </div>
              </ModalFooter>
            </div>
          </div>
        </Modal>
        {/* ----------Revise Modal Start---------------- */}
        {this.state.showRevisedPopUp && <Modal className="modal-lg" isOpen={this.state.showRevisedPopUp} >
          <div className={"modal-bg" + (this.state.OpenVersionModal == true ? 'open' : '')}>
            <div className="modalheads">
              <ModalHeader HeaderStyle="modal-header">
                <div className="modal-text"><h4>Document Action</h4></div>
                <button type="button" className="close" aria-label="Close" onClick={(e) => this.handleCancel()} >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
            </div>
            <div>
              <ModalBody Style="modal-body">
                <div className="row ">
                  <div className="col-sm-6">
                    {this.state.ActedgroupId == 20 && this.state.approvalStatus == 0 ?
                      "Upload Document"
                      :
                      "Upload Document (Optional)"
                    }
                  </div>
                  <div className="col-sm-6">
                    <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInputforRevision(e) }} id="exampleFormControlFile2" />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-6">
                    Comment
                  </div>
                  <div className="col-sm-6">
                    <textarea className="form-control" onChange={(e) => this.formChange(e)}>{this.state.reviseForm.comment}</textarea>
                  </div>
                </div>
              </ModalBody>
            </div>
            <div className="">
              <ModalFooter FooterStyle="modal-footer">
                <div>
                  <button className="btn2 btn-sms1 rounded-pill mt-2 ml-2 float-right" onClick={() => this.formSaveAction()} type="submit">Save</button>
                  <button className="btn2 btn-sms1 rounded-pill mt-2 ml-2 " onClick={() => this.handleCancel()} type="submit">Close</button>

                </div>
              </ModalFooter>
            </div>
          </div>
        </Modal>
        }
        {/* ----------Revise Modal End---------------- */}
        <div className="row ">
          <div className="col-md-8 header"><b>Logistics</b></div>
        </div>
        {group[20] ?
          <>
            <div className="row">
              <div className="col" style={{ display: "flex" }}>
                <div style={{ width: "25%" }}>
                  <Select maxMenuHeight={500} placeholder="Select PO" value={this.state.POList.find(obj => obj.value === this.state.PoId)} styles={customStyles} options={this.state.POList} onChange={(e) => this.handleSelectPO(e)} />
                </div>
                <div style={{ width: "25%" }}>
                  <Select maxMenuHeight={500} placeholder="PO Line Item" value={this.state.POLineItemList.find(obj => obj.value === this.state.PoLIneItemId)} styles={customStyles} options={this.state.POLineItemList} onChange={(e) => this.handleSelectPOLineItems(e)} />
                </div>
                <div style={{ width: "25%" }}>
                  <Select maxMenuHeight={500} placeholder="Vendor Code" value={this.state.ThirdPartyVendorList.find(obj => obj.value === this.state.VendorCode)} styles={customStyles} options={this.state.ThirdPartyVendorList} onChange={(e) => this.handleSelectVendor(e)} />
                </div>
                <div style={{ width: "25%" }}>
                  <Select maxMenuHeight={500} placeholder="Payment Type" value={this.state.PaymentType.find(obj => obj.value === this.state.SelectedPaymentType)} styles={customStyles} options={this.state.PaymentType} onChange={(e) => this.handleSelectPaymentType(e)} />
                </div>
                <CurrencyInput style={{ width: "auto" }} allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.InvoiceAmount} placeholder='Enter Amount' onValueChange={(value, name) => this.InvoiceAmountInput(value)} />
                <input style={{ border: 'none' }} type='file' className='form-control' onChange={(e) => this.handleFile(e)} id='exampleFormControlFile2' />
                <button className='btn2 btn-sms1 rounded-pill' style={{ width: '-webkit-fill-available' }} onClick={() => this.fileUpload()}> Upload & Request</button>
              </div>
            </div>
            {this.state.PoId ?
              <div className='logistics-details'>
                <div className='Container-fluid p-4'>
                  <div className='row'>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>PO Amount:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.Currency + " " + this.state.PODetailsDisplayData.POAmount}</div>
                      </div>
                    </div>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>PO Date:</b></div>
                        <div className='col'>{formatDate(this.state.PODetailsDisplayData.PODate)}</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Vendor Name:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.VendorSAPId + " - " + this.state.PODetailsDisplayData.VendorName}</div>
                      </div>
                    </div>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Location:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.Location}</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Vendor Email:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.VendorEmail}</div>
                      </div>
                    </div>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>WBS Code:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.WBSCode}</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Material Number:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.MaterialNumber}</div>
                      </div>
                    </div>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Material Name:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.MaterialShortText}</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Size/ Dimensions:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.SizeOrDimensions}</div>
                      </div>
                    </div>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Item Description:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.ItemDescription}</div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Incoterms:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.incoTerms}</div>
                      </div>
                    </div>
                    <div className='col'>
                      <div className='row'>
                        <div className='col'><b>Plant Code:</b></div>
                        <div className='col'>{this.state.PODetailsDisplayData.PlantCode}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null}
          </>
          : null}
        <table className="table1 mt-4">
          <thead className="thead" style={{ backgroundColor: "#0989CB" }}>
            <tr>
              <th scope="col">Project No.</th>
              <th scope="col">PO No.</th>
              <th scope="col">LineItem No.</th>
              <th scope="col">Third Party VendorCode</th>
              <th scope="col">Payment Type</th>
              <th scope="col">Amount</th>
              <th scope="col">Submitted On</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.state.tableData.map((item, index) =>
              <tr key={index}>
                <td>{item.WBSCode ? item.WBSCode.includes('ET') ? (item.WBSCode).slice(0, 11) : (item.WBSCode).slice(0, 6) : ""}</td>
                <td>{item.POSAPId}</td>
                <td>{item.POLineItemSAPCode}</td>
                <td>{item.ThirdPartyVendorCode}</td>
                <td>{item.PaymentType}</td>
                <td>{item.Amount ? numberWithCommas(item.Amount) : ''}</td>
                <td>{item.CreatedOn ? formatDate(item.CreatedOn) : ''}</td>
                <td>
                  {group[8] ?
                    item.PaymentType == 'Custom duty' ?
                      <>
                        <div className='text-center'>
                          <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="code-branch" color='black' cursor="pointer" title="Document Version" size="2x" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                          <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="file-download" color='black' cursor="pointer" title="Download" size="2x" />
                          </a>
                          {item.ApprovalStatusByTreasury == 0 && item.ApprovalStatusByAP == 0 ?
                            <>
                              <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="check-circle" color='green' cursor="pointer" title="Approve" size="2x" onClick={() => this.revisePopUpAction(item, 1, 8)} />
                              <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="history" color='blue' cursor="pointer" title="Revise" size="2x" onClick={() => this.revisePopUpAction(item, 2, 8)} />
                            </>
                            : null}
                          <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="sms" color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(item.DocumentId, item.POId, item.POLineItemId)} />
                          <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="info-circle" color='black' cursor="pointer" title="Details" size="2x" onClick={() => this.Docmodal(item.LogisticsRequestId)} />
                        </div>
                        <div className='text-center'>
                          {item.ApprovalStatusByTreasury == 1 ?
                            <span className={"badge badge-success"}>Payment Done and Approved by AP Team</span>
                            : item.ApprovalStatusByAP == 2 || item.ApprovalStatusByTreasury == 2 ?
                              <span className={"badge " + this.state.docStatus[2]['badge']}>{this.state.docStatus[2]['title']}</span>
                              : <span className={"badge " + this.state.docStatus[item.ApprovalStatusByAP]['badge']}>{this.state.docStatus[item.ApprovalStatusByAP]['title']}</span>}
                        </div>
                      </>
                      : item.ApprovalStatusByAP == 0 && item.PaymentType !== 'Custom duty' ?
                        <>
                          <div className='text-center'>
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="code-branch" color='black' cursor="pointer" title="Document Version" size="2x" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                              <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="file-download" color='black' cursor="pointer" title="Download" size="2x" />
                            </a>
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="check-circle" color='green' cursor="pointer" title="Approve" size="2x" onClick={() => this.Acceptmodal(item, 1, 8)} />
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="history" color='blue' cursor="pointer" title="Revise" size="2x" onClick={() => this.revisePopUpAction(item, 2, 8)} />
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="sms" color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(item.DocumentId, item.POId, item.POLineItemId)} />
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="info-circle" color='black' cursor="pointer" title="Details" size="2x" onClick={() => this.Docmodal(item.LogisticsRequestId)} />
                          </div>
                          <div className='text-center'>
                            <span className={"badge " + this.state.docStatus[item.ApprovalStatusByAP]['badge']}>{this.state.docStatus[item.ApprovalStatusByAP]['title']}</span>
                          </div>
                        </>
                        : <>
                          <div className='text-center'>
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="code-branch" color='black' cursor="pointer" title="Document Version" size="2x" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                              <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="file-download" color='black' cursor="pointer" title="Download" size="2x" />
                            </a>
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="sms" color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(item.DocumentId, item.POId, item.POLineItemId)} />
                            <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="info-circle" color='black' cursor="pointer" title="Details" size="2x" onClick={() => this.Docmodal(item.LogisticsRequestId)} />
                          </div>
                          <div className='text-center'>
                            <span className={"badge " + this.state.docStatus[item.ApprovalStatusByAP]['badge']}>{this.state.docStatus[item.ApprovalStatusByAP]['title']}</span>
                          </div>
                        </>
                    // : null
                    // group[9] && item.PaymentType == 'Custom duty' ?
                    //   item.ApprovalStatusByTreasury == 0 ?
                    //     <>
                    //       <div className='text-center'>
                    //         <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="code-branch" color='black' cursor="pointer" title="Document Version" size="2x" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                    //         <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                    //           <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="file-download" color='black' cursor="pointer" title="Download" size="2x" />
                    //         </a>
                    //         {item.ApprovalStatusByAP !== 2 && item.ApprovalStatusByTreasury !== 2 ?
                    //           <>
                    //             <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="check-circle" color='green' cursor="pointer" title="Approve" size="2x" onClick={() => this.revisePopUpAction(item, 1, 9)} />
                    //             <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="history" color='blue' cursor="pointer" title="Revise" size="2x" onClick={() => this.revisePopUpAction(item, 2, 9)} />
                    //           </>
                    //           : null}
                    //         <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="sms" color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(item.DocumentId, item.POId, item.POLineItemId)} />
                    //         <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="info-circle" color='black' cursor="pointer" title="Details" size="2x" onClick={() => this.Docmodal(item.LogisticsRequestId)} />
                    //       </div>
                    //       <div className='text-center'>
                    //         {item.ApprovalStatusByAP == 1 && item.ApprovalStatusByTreasury == 0 ?
                    //           <span className={"badge badge-info"}>Approved By AP Team</span>
                    //           : item.ApprovalStatusByAP == 2 || item.ApprovalStatusByTreasury == 2 ?
                    //             <span className={"badge " + this.state.docStatus[2]['badge']}>{this.state.docStatus[2]['title']}</span>
                    //             : <span className={"badge " + this.state.docStatus[item.ApprovalStatusByTreasury]['badge']}>{this.state.docStatus[item.ApprovalStatusByTreasury]['title']}</span>
                            // }
                          // </div>
                        // </>
                      //   : <>
                      //     <div className='text-center'>
                      //       <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="code-branch" color='black' cursor="pointer" title="Document Version" size="2x" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                      //       <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                      //         <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="file-download" color='black' cursor="pointer" title="Download" size="2x" />
                      //       </a>
                      //       <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="sms" color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(item.DocumentId, item.POId, item.POLineItemId)} />
                      //       <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="info-circle" color='black' cursor="pointer" title="Details" size="2x" onClick={() => this.Docmodal(item.LogisticsRequestId)} />
                      //     </div>
                      //     <div className='text-center'>
                      //       {item.ApprovalStatusByTreasury == 1 ?
                      //         <span className={"badge badge-success"}>Payment Done and Approved by Treasury</span>
                      //         : <span className={"badge " + this.state.docStatus[item.ApprovalStatusByTreasury]['badge']}>{this.state.docStatus[item.ApprovalStatusByTreasury]['title']}</span>}
                      //     </div>
                      //   </>
                      // : <div className='text-center'>
                      //   <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="code-branch" color='black' cursor="pointer" title="Document Version" size="2x" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                      //   <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                      //     <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="file-download" color='black' cursor="pointer" title="Download" size="2x" />
                      //   </a>
                      //   {group[20] && (item.ApprovalStatusByAP == 2 || item.ApprovalStatusByTreasury == 2) ?
                      //     <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"cloud-upload-alt"} color='black' cursor="pointer" title="Upload" size="2x" onClick={() => this.revisePopUpAction(item, 0, 20)} />
                      //     : null}
                      //   <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="sms" color={"block"} title="Comments" size="2x" onClick={() => this.rowClick(item.DocumentId, item.POId, item.POLineItemId)} />
                      //   <FontAwesomeIcon className="align-middle mt-2 pr-2" icon="info-circle" color='black' cursor="pointer" title="Details" size="2x" onClick={() => this.Docmodal(item.LogisticsRequestId)} />
                      //   <div className='text-center'>
                      //     {item.PaymentType == 'Custom duty' && item.ApprovalStatusByTreasury == 1 ?
                      //       <span className={"badge badge-success"}>Payment Done and Approved by Treasury</span>
                      //       : item.PaymentType == 'Custom duty' && item.ApprovalStatusByTreasury == 0 && item.ApprovalStatusByAP == 1 ?
                      //         <span className={"badge badge-info"}>Approved By AP Team</span>
                      //         : item.PaymentType !== 'Custom duty' ?
                      //           <span className={"badge " + this.state.docStatus[item.ApprovalStatusByAP]['badge']}>{this.state.docStatus[item.ApprovalStatusByAP]['title']}</span>
                      //           : null}
                      //   </div>
                      // </div>
                    :null  
                    }
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  }
}



const mapStateToProps = (state) => ({ poDetails: state.poDetails, file: state.file, masterReducerData: state.masterReducer })
export default connect(mapStateToProps, { LogistcsPOsAndLineItem, RequestPayemtForLogistics, uploadFileGeneric, GenericUploadVersionFile, GenericPostCommentsbyDocumentID, getallMasterData })(ImportLogistics)
